import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";

import authModule from './auth.module'
import ideaModule from './idea.module'


Vue.use(Vuex)

export const store = new Vuex.Store({
    plugins: [createPersistedState()],

    modules: {
        auth: authModule,
        idea: ideaModule
    },

    state: {
        // token: localStorage.getItem('token') || '',
        progress: false,
        snackbar: false,
        text: "",
        color: "cyan darken-2",
        timeout: 5000,
    },

    getters: {},

    mutations: {
        loading(state, val) {
            state.progress = val
        },
        notification(state, payload){
            state.snackbar = payload.status
            state.text = payload.text,
            state.color = payload.color
        },
        showSnackbar(state, val){
            state.snackbar = val
        }
    },

    actions: {
        async timeout({state}) {
            await Promise(resolve => setTimeout(resolve, state.timeout));

        }
    }
})